// extracted by mini-css-extract-plugin
module.exports = {"container":"SocialLinks_container__spUv_","buttonBlock":"SocialLinks_buttonBlock__T0lap"};